import { render } from "./AdminSettingFeesAndTaxes.vue?vue&type=template&id=b61fd6d2"
import script from "./AdminSettingFeesAndTaxes.vue?vue&type=script&lang=js"
export * from "./AdminSettingFeesAndTaxes.vue?vue&type=script&lang=js"

import "./AdminSettingFeesAndTaxes.vue?vue&type=style&index=0&id=b61fd6d2&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__